import { SEO_MARKETS, SEO_MARKET_RADIUS_MILES } from 'constants/seoMarkets';
import { calculateHaversineDistance } from 'utils/shared/geo/calculateHaversineDistance';
import { isLaunchCityMarket } from './isLaunchCityMarket';

interface GeoPoint {
  latitude?: number | string | null;
  longitude?: number | string | null;
}

export const isSeoCityMarket = (point?: GeoPoint | null) => {
  if (isLaunchCityMarket(point)) {
    return true;
  }

  const latitude = Number(point?.latitude);
  const longitude = Number(point?.longitude);

  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    return false;
  }

  return SEO_MARKETS.some((market) => {
    const distance = calculateHaversineDistance({
      coord1: { latitude, longitude },
      coord2: { latitude: market.latitude, longitude: market.longitude },
      unit: 'miles',
    });

    return distance <= SEO_MARKET_RADIUS_MILES;
  });
};
